import createIcon from '../../createIcon';

/**
 * @component @name WbIridescent
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC45OTQ5MiAxNS4wMDA4SDE4Ljk5NDlWOS4wMDA3OEg0Ljk5NDkyVjE1LjAwMDhaTTEwLjk5NDkgMS4wNTA3OFY0LjAwMDc4SDEyLjk5NDlWMS4wNTA3OEgxMC45OTQ5Wk0xOS4wMzQ5IDMuNTUwNzhMMTcuMjQ0OSA1LjM0MDc4TDE4LjY1NDkgNi43NTA3OEwyMC40NTQ5IDQuOTYwNzhMMTkuMDM0OSAzLjU1MDc4Wk0xMi45OTQ5IDIyLjk1MDhWMjAuMDAwOEgxMC45OTQ5VjIyLjk1MDhIMTIuOTk0OVpNMjAuNDQ0OSAxOS4wNDA4TDE4LjY0NDkgMTcuMjUwOEwxNy4yMzQ5IDE4LjY2MDhMMTkuMDI0OSAyMC40NjA4TDIwLjQ0NDkgMTkuMDQwOFpNMy41NDQ5MiA0Ljk2MDc4TDUuMzM0OTIgNi43NTA3OEw2Ljc0NDkyIDUuMzQwNzhMNC45NTQ5MiAzLjU1MDc4TDMuNTQ0OTIgNC45NjA3OFpNNC45NTQ5MiAyMC40NTA4TDYuNzQ0OTIgMTguNjUwOEw1LjMzNDkyIDE3LjI0MDhMMy41NDQ5MiAxOS4wMzA4TDQuOTU0OTIgMjAuNDUwOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WbIridescent = createIcon('WbIridescent', [
  [
    'path',
    {
      d: 'M4.99492 15.0008H18.9949V9.00078H4.99492V15.0008ZM10.9949 1.05078V4.00078H12.9949V1.05078H10.9949ZM19.0349 3.55078L17.2449 5.34078L18.6549 6.75078L20.4549 4.96078L19.0349 3.55078ZM12.9949 22.9508V20.0008H10.9949V22.9508H12.9949ZM20.4449 19.0408L18.6449 17.2508L17.2349 18.6608L19.0249 20.4608L20.4449 19.0408ZM3.54492 4.96078L5.33492 6.75078L6.74492 5.34078L4.95492 3.55078L3.54492 4.96078ZM4.95492 20.4508L6.74492 18.6508L5.33492 17.2408L3.54492 19.0308L4.95492 20.4508Z',
      key: '11oolz',
    },
  ],
]);

export default WbIridescent;
